<script>
  import Reports from './components/Reports.svelte'
  import Rankings from './components/Rankings.svelte'
  import { isRanking } from './store.js'
</script>

{#if $isRanking}
  <Rankings />
{:else}
  <Reports />
{/if}
